import type { Meta } from "@storybook/react";

import type { GetIllustrationIconProps } from "@/ui/theme/icons/illustrations/groupClasses";
import {
  getIllustrationIcon,
  IllustrationName,
} from "@/ui/theme/icons/illustrations/groupClasses";

const meta: Meta<GetIllustrationIconProps> = {
  argTypes: {
    height: { control: "number" },
    iconName: {
      control: "select",
      options: Object.values(IllustrationName),
    },
    width: { control: "number" },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: getIllustrationIcon as any,
  title: "Theme/Illustrations",
};

export default meta;

export const Primary = {
  args: {
    height: 48,
    iconName: "flag",
    width: 48,
  },
  render: ({ height, iconName, width }: GetIllustrationIconProps) =>
    getIllustrationIcon({ height, iconName, width }),
};
